export default "__VITE_ASSET__7f807a01__"